var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.closeModal
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Change Quota ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "10"
                    }
                  },
                  [
                    _c("v-slider", {
                      attrs: {
                        outlined: "",
                        name: "Quota",
                        "error-messages": _vm.errors.collect("Quota"),
                        type: "number",
                        label: "New quota value",
                        "hide-details": "",
                        max: "10000",
                        min: "1"
                      },
                      model: {
                        value: _vm.value,
                        callback: function callback($$v) {
                          _vm.value = $$v
                        },
                        expression: "value"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "2"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.value) + " MB ")]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.closeModal
                }
              },
              [_vm._v(" Cancel ")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.query_loading
                },
                on: {
                  click: _vm.setQuota
                }
              },
              [_vm._v(" Save Changes ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }